import template from './toggler.html';

const DIRECTIVE_NAME = Toggler.DIRECTIVE_NAME = 'ktToggler';
export default function Toggler() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TogglerController,
        controllerAs: 'togglerCtrl',
        scope: {
            label: `@${DIRECTIVE_NAME}Label`,
            labelShown: `@${DIRECTIVE_NAME}LabelShown`,
            isOpened: `=${DIRECTIVE_NAME}`,
        },
        link: function($scope, $elem, $attrs, togglerCtrl) {
            togglerCtrl.$onInit();
        },
    };
}

export function TogglerController(l10nService) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        toggle,
    });

    function $onInit() {
        translateLabels();
    }

    function toggle() {
        vm.isOpened = !vm.isOpened;
    }

    function translateLabels() {
        vm.labelTranslated = l10nService.localize(vm.label);
        vm.labelShownTranslated = l10nService.localize(vm.labelShown);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/toggler/toggler-component.js